// removed by extract-text-webpack-plugin
module.exports = {"option":"index__option___2fge9","reverse":"index__reverse___2aPiH","border":"index__border___3uKSr","is-browser":"index__is-browser___3fig_","isBrowser":"index__is-browser___3fig_","active":"index__active___2ZvmW","is-more-weight":"index__is-more-weight___1NFDZ","isMoreWeight":"index__is-more-weight___1NFDZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/atoms/Option/index.css
// module id = 715
// module chunks = 12